import "./SingleMenubar.css";

import {
	setAppBarSelectedItem,
	setDrawerCurrentState,
	setDrawerWidthCurrentState,
} from "../../store/actions";
import { useEffect, useState } from "react";

import { Box } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

interface MenuItem {
	label: string;
	expanded?: string;
	icon?: string;
	command?: () => void;
	items?: MenuItem[];
	hideLabel?: boolean;
	menuHeaderLabel?: boolean;
}

const SingleMenubar: React.FC<{ menuItems: MenuItem[] }> = ({ menuItems }) => {
	const dispatch = useDispatch();

	const [selectedMainAppBarItem, setSelectedMainAppBarItem] = useState<
		string | null
	>(localStorage.getItem("selectedMainAppBarItem") || null);

	let navigate = useNavigate();
	const handleMenuClick = (item: MenuItem) => {
		if (item.label !== "Logout") {
			if (item.items && item.items.length > 0) {
				setSelectedMainAppBarItem(item.label);
				localStorage.setItem("selectedMainAppBarItem", item.label);
				dispatch(setAppBarSelectedItem({ appBarSelectedItem: item.label }));

				if (!item.items[0].command && item.items[0].menuHeaderLabel) {
					if (!item.items[1].command && item.items[1].items) {
						item.items[1].items[1].command?.();
					} else {
						item.items[1].command?.();
					}
				} else if (!item.items[0].command && item.items[0].items) {
					item.items[0].items[0].command?.();
				} else if (!item.items[0].command && !item.items[0].items && item.items[1].items) {  // this is for header in add-ons like accounting 
					item.items[1].items[0].command?.();
				} else {
					item.items[0].command?.();
				}
			} else {
				setSelectedMainAppBarItem(item.label);
				localStorage.setItem("selectedMainAppBarItem", item.label);
				dispatch(setAppBarSelectedItem({ appBarSelectedItem: item.label }));
			}
		} else {
			let path = "/logout";
			navigate(path);
		}
	};



	useEffect(() => {
		if (menuItems) {
			// const mainMenuSelectedItem = menuItems.find((item:any) => item.expanded)
			const mainMenuSelectedItem = Array.isArray(menuItems)
				? menuItems.find((item) => item.expanded)
				: undefined;

			if (mainMenuSelectedItem) {
				setSelectedMainAppBarItem(mainMenuSelectedItem.label);
				localStorage.setItem(
					"selectedMainAppBarItem",
					mainMenuSelectedItem.label
				);
				dispatch(
					setAppBarSelectedItem({
						appBarSelectedItem: mainMenuSelectedItem.label,
					})
				);
			} else {
				setSelectedMainAppBarItem("");
			}
		} else {
			setSelectedMainAppBarItem(null);
			localStorage.setItem("selectedMainAppBarItem", "");
		}
	}, [menuItems]);

	return (
		<>
			<div className="single-app-bar">
				<ul className="p-0 m-0">
					{menuItems.map((item, index) => (
						item.hideLabel ? null : (
							<li
								key={index}
								onClick={() => handleMenuClick(item)}
								className={`cursor-pointer p-3 rounded ${selectedMainAppBarItem === item.label
									? "selected-app-bar-item-bg-color text-white"
									: "hover:bg-gray-300"
									}`}
							// style={{marginBottom:"3px!important"}}
							>
								{/* {item?.icon && React.isValidElement(item.icon)
									? item.icon
									: null} */}
								{item.label}
							</li>
						)
					))}
				</ul>
			</div>
		</>
	);
};

export default SingleMenubar;
